var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 86,
    viewBox: "0 0 80 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3539 1.92637C42.7877 -0.642122 37.2123 -0.642123 32.6461 1.92637L7.64608 15.9889C2.92293 18.6456 0 23.6434 0 29.0625V70.2898C0 78.5741 6.71573 85.2898 15 85.2898H65C73.2843 85.2898 80 78.5741 80 70.2898V29.0625C80 23.6434 77.0771 18.6456 72.3539 15.9889L47.3539 1.92637ZM55 72.7898C57.7614 72.7898 60 70.5512 60 67.7898V67.7898C60 65.0284 57.7614 62.7898 55 62.7898H25C22.2386 62.7898 20 65.0284 20 67.7898V67.7898C20 70.5512 22.2386 72.7898 25 72.7898H55Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68H55",
    stroke: "#1E293B",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.ef5cb32f0483e7c61ce655bba15c8414.svg";
export { ForwardRef as ReactComponent };